import { CSSProperties } from "@material-ui/core/styles/withStyles";

const container: CSSProperties = {
  maxWidth: 750,
  width: "100%",
  margin: "0 auto",
};

const actionHeader: CSSProperties = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
};

const rescheduleBtn: CSSProperties = {
  marginRight: 15,
};

export const styles = {
  container,
  actionHeader,
  rescheduleBtn,
};
